import apiClient from './api';
import type {
  SaveTranscriptPayload,
  AutoTranscribePayload,
  ApiResponse,
} from '../types/api.types';

export const transcriptsService = {
  // Save/update manual transcription
  async saveTranscript(payload: SaveTranscriptPayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/save/transcript', payload);
    return response.data;
  },

  // Request auto-transcription
  async autoTranscribe(payload: AutoTranscribePayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/auto/transcribe', payload);
    return response.data;
  },
};
